
import { Link } from 'react-router-dom'
import './NavBar.css'
import { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../../Firebase/InitFirebase';

export default function NavBar({show_login}) {

    const [username, set_username] = useState("");

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, currentUser => {
            if(currentUser) set_username(currentUser.displayName) ;
            else set_username("")
        })
        return () => unsubscribe();
    }, []);


    return (
        <div className = "NavBar">
            <Link to='/' className = "Nav-Box">
                Problems
            </Link>

            <Link to='/Courses' className = "Nav-Box">
                Courses
            </Link>

            <div className = "Nav-Box">
                Support Us!
            </div>
            
            <Link to='/Profile' className = "Nav-Box-Login">
                {username !== "" ? username : "Login" }
            </Link>
        </div>
    );
}